import { colors } from '../../colors';
var location = {
  bgColor: colors.nvaBrightBlue,
  cardBgColor: colors.white,
  secondaryBgColor: colors.white,
  cardShadow: colors.black,
  graphiteColor: colors.graphite
};
export default location;